export const PaymentValidationMessages = {
    amountExceedsBalance: 'Cannot enter more than balance due.',
} as const;
